var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 346,
    viewBox: "0 0 24 346",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1.33333 11C1.33333 16.891 6.10896 21.6667 12 21.6667C17.891 21.6667 22.6667 16.891 22.6667 11C22.6667 5.10896 17.891 0.333333 12 0.333333C6.10896 0.333333 1.33333 5.10896 1.33333 11ZM12 346L23.547 326L0.453008 326L12 346ZM12 11L10 11L10 328L12 328L14 328L14 11L12 11Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector9);
export default __webpack_public_path__ + "static/media/Vector 9.4c797f71aa2384246d1c271184bef374.svg";
export { ForwardRef as ReactComponent };